import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Package, MapPin, Phone, CheckCircle2 } from "lucide-react";
import { fmtDate } from "@/lib/utils-format";

export default function MobileDeliveries() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("pending"); // pending | delivered

  const load = async () => {
    try {
      const status = tab === "delivered" ? "delivered" : undefined;
      const { data } = await api.get("/mobile/deliveries" + (status ? `?status=${status}` : ""));
      setItems(data);
    } catch (e) {}
  };
  useEffect(() => { load(); }, [tab]);

  return (
    <div className="p-4 space-y-4" data-testid="m-deliveries-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-[#8B7355]">On-field</div>
        <h1 className="font-[Outfit] text-2xl font-semibold tracking-tight mt-0.5">My Deliveries</h1>
      </div>

      <div className="flex bg-white border border-[#EAE5D9] rounded-md p-1 text-sm">
        {[
          { k: "pending", label: "Pending" },
          { k: "delivered", label: "Delivered" },
        ].map((t) => (
          <button
            key={t.k}
            onClick={() => setTab(t.k)}
            data-testid={`m-tab-${t.k}`}
            className={`flex-1 py-2 rounded-md ${tab === t.k ? "bg-[#C05621] text-white" : "text-[#5C4033]"}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {items.length === 0 ? (
        <div className="bg-white border border-[#EAE5D9] rounded-xl p-8 text-center text-[#8B7355]" data-testid="m-deliveries-empty">
          <Package className="w-10 h-10 mx-auto mb-2 opacity-40" />
          <div className="text-sm">
            {tab === "pending" ? "No pending deliveries assigned to you." : "No completed deliveries yet."}
          </div>
        </div>
      ) : (
        <ul className="space-y-3">
          {items.map((d) => (
            <li key={d.id}>
              <Link
                to={`/m/deliveries/${d.id}`}
                data-testid={`m-delivery-${d.id}`}
                className="block bg-white border border-[#EAE5D9] rounded-xl p-4 hover:border-[#C05621]"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-[10px] uppercase tracking-widest text-[#C05621]">{d.doc_type}</span>
                      {d.delivery_status === "delivered" && (
                        <span className="text-[10px] uppercase tracking-widest text-emerald-700 flex items-center gap-1">
                          <CheckCircle2 className="w-3 h-3" /> Delivered
                        </span>
                      )}
                    </div>
                    <div className="font-semibold mt-0.5 truncate">{d.number}</div>
                    <div className="text-sm text-[#2C1810] mt-1 truncate">{d.customer_snapshot?.name}</div>
                    <div className="flex items-center gap-3 text-xs text-[#8B7355] mt-2 flex-wrap">
                      {d.customer_snapshot?.city && (
                        <span className="flex items-center gap-1"><MapPin className="w-3 h-3" />{d.customer_snapshot.city}</span>
                      )}
                      {d.customer_snapshot?.phone && (
                        <span className="flex items-center gap-1"><Phone className="w-3 h-3" />{d.customer_snapshot.phone}</span>
                      )}
                    </div>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="font-semibold">₹{Math.round(d.grand_total || 0).toLocaleString("en-IN")}</div>
                    <div className="text-[10px] text-[#8B7355]">{fmtDate(d.created_at)}</div>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
